(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5405],{

/***/ 5557:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(3678);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 3678:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(828);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7294);
/* harmony import */ var next_seo__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2962);
/* harmony import */ var _components_Header__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(798);
/* harmony import */ var _components_Footer__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(3193);
/* harmony import */ var _components_home_HomeWidgetMobile__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(9748);
/* harmony import */ var _components_home_HomeCarousel__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(350);
/* harmony import */ var _components_home_HomeNews__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(7247);
/* harmony import */ var _components_home_HomeUsefool__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(6942);
/* harmony import */ var _components_home_HomeWidget__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(7166);
/* harmony import */ var _data_location_json__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(3479);
/* harmony import */ var _context_location__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(637);














var HomeSEO = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 1084).then(__webpack_require__.bind(__webpack_require__, 1084));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(1084)
            ];
        }
    }
});
var HomePage = function() {
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)((0,_context_location__WEBPACK_IMPORTED_MODULE_12__/* .useLocationProvider */ .b8)(), 1), locationState = ref[0];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react__WEBPACK_IMPORTED_MODULE_2__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_seo__WEBPACK_IMPORTED_MODULE_3__/* .NextSeo */ .PB, {
                title: "База - каталог и новости недвижимости в России",
                description: "Продажа аренда недвижимости в России и областях. Объявления, каталог, листинг, мультилистинг, карта, поиск, цены, купить, продать, арендовать, сдать, снять недвижимость квартиры студии однушки двушки трешки евродвушки евротрешки дома участки таунхаусы аппартаменты офис склад склады офисы коммерция коммерчесская недвижимость. Новости недвижимости в России: последние новости о недвижимости, ипотеке, спрос, аналитика, изменения в налогах, ключевая ставка, новости росреестра, новости ипотека, блог о недвижимости",
                openGraph: {
                    url: "https://".concat("baza.estate"),
                    type: "website",
                    title: "База - каталог и новости недвижимости в России",
                    description: "Продажа аренда недвижимости в России и областях. Объявления, каталог, листинг, мультилистинг, карта, поиск, цены, купить, продать, арендовать, сдать, снять недвижимость квартиры студии однушки двушки трешки евродвушки евротрешки дома участки таунхаусы аппартаменты офис склад склады офисы коммерция коммерчесская недвижимость. Новости недвижимости в России: последние новости о недвижимости, ипотеке, спрос, аналитика, изменения в налогах, ключевая ставка, новости росреестра, новости ипотека, блог о недвижимости",
                    images: [
                        {
                            url: "/images/og-preview.png"
                        }
                    ],
                    site_name: "Baza.estate - база недвижимости"
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Header__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("main", {
                className: "core",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_home_HomeWidget__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                        region: locationState.code
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_home_HomeWidgetMobile__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        region: locationState.code
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_home_HomeCarousel__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                        title: "Рекомендуемые на вторичке",
                        category: "квартира",
                        link: "flats"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_home_HomeNews__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {}),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_home_HomeCarousel__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                        title: "Популярные в коммерции",
                        category: "коммерция",
                        link: "commercial"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_home_HomeUsefool__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                        region: locationState.code,
                        locations: _data_location_json__WEBPACK_IMPORTED_MODULE_11__
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(HomeSEO, {})
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Footer__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                seo: "Купить продать снять сдать недвижимость в России"
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (HomePage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [41,2962,5675,5518,6265,798,3193,360,3924,9877,9774,2888,179], function() { return __webpack_exec__(5557); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);